import { render, staticRenderFns } from "./LifeChampsHeader.vue?vue&type=template&id=abcc9362&"
import script from "./LifeChampsHeader.vue?vue&type=script&lang=js&"
export * from "./LifeChampsHeader.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/header.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports